import React from 'react';
export function FlatSprout({
  className = ''
}: {
  className?: string;
}) {
  return <svg width="150" height="120" viewBox="0 60 150 120" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-63">
      {/* Base/Ground */}
      <ellipse cx="75" cy="160" rx="45" ry="15" fill="rgba(197,216,45,0.1)" data-id="element-64" />

      {/* Stem */}
      <path d="M73 160 C 73 120, 65 90, 75 70" stroke="#5D4037" strokeWidth="6" strokeLinecap="round" fill="none" data-id="element-65" />

      {/* Left Leaf */}
      <path d="M70 100 C 40 90, 30 110, 35 125 C 50 120, 65 115, 70 100 Z" fill="#A8BF24" data-id="element-66" />

      {/* Right Leaf */}
      <path d="M74 85 C 100 70, 115 85, 110 105 C 95 105, 80 95, 74 85 Z" fill="#C5D82D" data-id="element-67" />
    </svg>;
}